import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { TipoEnderecoModel } from 'app/model/endereco/tipoendereco.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TipoenderecoService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  getTipoEnderecos(): Observable<ResponsePageable>{
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-tipoendereco', this.httpOptions);
  }

  getPageTipoEndereco(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-tipoendereco?page=${page}&size=${size}`, this.httpOptions);
  }


  postTipoEndereco(tipoEndereco: TipoEnderecoModel): Observable<TipoEnderecoModel>{
    return this.httpClient.post<TipoEnderecoModel>(this.apiURL + '/new/adicionar-tipoendereco', tipoEndereco, this.httpOptions);
  }

  putTipoEndereco(tipoEndereco: TipoEnderecoModel): Observable<TipoEnderecoModel>{
    return this.httpClient.put<TipoEnderecoModel>(this.apiURL + '/edit/editar-tipoendereco' , tipoEndereco, this.httpOptions);
  }

  deleteTipoEndereco(id: any) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + '/delete/deletar-tipoendereco/' + id, { headers, responseType: 'text'});
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/endereco/tipoendereco.service.ts